import { User, WdsModule } from "../Login/LoginState";

export const hasAccess = (user: User | undefined, module: WdsModule) => {
  return user?.modules.includes(module);
};
